import { useId, useRef, useState } from "react";
import { Alert, IconButton, Popover, Stack, Typography } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import CloseRounded from "@mui/icons-material/CloseRounded";
import { useTranslation } from "react-i18next";
import ReadModelEvidence from "./ReadModelEvidence";

export default function ReadModelInfo({ label, message, metadata, fallbackReason }) {
  const { t } = useTranslation(["freigabe", "gemeinsam"]);
  const [anchor, setAnchor] = useState(null);
  const id = useId();
  const trigger = useRef(null);
  const title = t("stageBranches.readModel.infoTitle");
  const close = () => setAnchor(null);
  return <Stack component="span" direction="row" alignItems="center" spacing={0.5} sx={{ minWidth: 0, color: "var(--iio-text-2)" }}>
    <Typography component="span" variant="body2">{label}</Typography>
    <IconButton ref={trigger} type="button" aria-label={title} aria-haspopup="dialog" aria-expanded={Boolean(anchor)}
      aria-controls={anchor ? id : undefined} onClick={event => setAnchor(event.currentTarget)}
      sx={{ width: 44, height: 44, flexShrink: 0, color: "inherit" }}>
      <InfoOutlined sx={{ fontSize: 18 }}/>
    </IconButton>
    <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={close}
      TransitionProps={{ onExited: () => trigger.current?.focus() }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{ id, role: "dialog", "aria-labelledby": `${id}-title`, className: "iio", sx: {
        width: 420, maxWidth: "calc(100vw - 32px)", p: 2, borderRadius: 2,
        bgcolor: "var(--iio-bg-1)", color: "var(--iio-text-1)", border: "1px solid var(--iio-border)",
      } }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Typography id={`${id}-title`} component="h2" variant="subtitle1" sx={{ fontWeight: 600 }}>{title}</Typography>
        <IconButton onClick={close} aria-label={t("gemeinsam:aktion.schliessen")} sx={{ width: 44, height: 44, color: "inherit" }}><CloseRounded/></IconButton>
      </Stack>
      <Alert severity="info" role="note" variant="standard" sx={{ mt: 1, bgcolor: "transparent", color: "inherit", p: 0,
        "& .MuiAlert-icon": { color: "var(--iio-info)" }, "& .MuiAlert-message": { minWidth: 0, overflowWrap: "anywhere" } }}>
        {message}
        <ReadModelEvidence metadata={metadata} fallbackReason={fallbackReason}/>
      </Alert>
    </Popover>
  </Stack>;
}
